import styled from 'astroturf/react';
import _SurveyQuestion from "QuestionStyles-SurveyQuestion.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/QuestionStyles.tsx?styleId=SurveyQuestion";
import _SurveyQuestionPrompt from "QuestionStyles-SurveyQuestionPrompt.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/QuestionStyles.tsx?styleId=SurveyQuestionPrompt";
import _SubPrompt from "QuestionStyles-SubPrompt.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/QuestionStyles.tsx?styleId=SubPrompt";
import _SurveyAnswersContainer from "QuestionStyles-SurveyAnswersContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/QuestionStyles.tsx?styleId=SurveyAnswersContainer";
import _AnswerContainer from "QuestionStyles-AnswerContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/QuestionStyles.tsx?styleId=AnswerContainer";
import _AnswerIcon from "QuestionStyles-AnswerIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/QuestionStyles.tsx?styleId=AnswerIcon";
import _AnswerText from "QuestionStyles-AnswerText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/QuestionStyles.tsx?styleId=AnswerText";


// DS2 isn't included in some places this is used
// which causes it to fail to compile, so I hardcoded the breakpoint
const TABLET_BREAKPOINT = 768;

export const SurveyQuestion = /*#__PURE__*/styled("div", null, {
  displayName: "SurveyQuestion",
  styles: _SurveyQuestion
});

export const SurveyQuestionPrompt = /*#__PURE__*/styled("div", null, {
  displayName: "SurveyQuestionPrompt",
  styles: _SurveyQuestionPrompt
});

export const SubPrompt = /*#__PURE__*/styled("div", null, {
  displayName: "SubPrompt",
  styles: _SubPrompt
});

export const SurveyAnswersContainer = /*#__PURE__*/styled("div", null, {
  displayName: "SurveyAnswersContainer",
  styles: _SurveyAnswersContainer
});

export const AnswerContainer = /*#__PURE__*/styled("button", null, {
  displayName: "AnswerContainer",
  styles: _AnswerContainer
});

export const AnswerIcon = /*#__PURE__*/styled("img", null, {
  displayName: "AnswerIcon",
  styles: _AnswerIcon
});

export const AnswerText = /*#__PURE__*/styled("div", null, {
  displayName: "AnswerText",
  styles: _AnswerText
});
